import { useMemo } from 'react';
import { pipe } from 'fp-ts/function';
import { array, boolean, ord } from 'fp-ts';
import { LoyaltyMembership } from '@mews-commander/data-access';
import { UnicodeEntity } from '@mews/enums';
import { SortableLoyaltyItem, loyaltySortingOrds } from '@mews-commander/utils';
import { useLoyaltyProgramsGetAllQuery } from '../../hooks';
import { WithPrimaryFlag } from './types';

export interface UseSortedLoyaltyMembershipsParams {
    loyaltyMemberships: Array<LoyaltyMembership>;
}

export const useSortedLoyaltyMemberships = ({ loyaltyMemberships }: UseSortedLoyaltyMembershipsParams) => {
    const { programs, tiers } = useLoyaltyProgramsGetAllQuery();

    return useMemo(
        () =>
            pipe(
                loyaltyMemberships,
                array.map(({ id, isPrimary, loyaltyProgramId, loyaltyTierId }) => ({
                    id,
                    isPrimary,
                    programName: programs[loyaltyProgramId]?.name || UnicodeEntity.Dash,
                    programType: programs[loyaltyProgramId]?.type || null,
                    tierName: loyaltyTierId ? tiers[loyaltyTierId]?.name : '',
                    tierOrdering: loyaltyTierId ? tiers[loyaltyTierId]?.ordering : 0,
                })),
                array.sortBy<SortableLoyaltyItem & WithPrimaryFlag>([primaryMembershipContramap, ...loyaltySortingOrds])
            ),
        [loyaltyMemberships, programs, tiers]
    );
};

const primaryMembershipContramap = pipe(
    boolean.Ord,
    ord.contramap((item: WithPrimaryFlag) => item.isPrimary)
);
